import { themeColor } from '../theme-color/theme-color.js';
import { primaryShade } from '../primary-shade/primary-shade.js';
import { getGradientColorStops } from './get-gradient-color-stops/get-gradient-color-stops.js';
function linearGradient(deg) {
  for (var _len = arguments.length, colors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    colors[_key - 1] = arguments[_key];
  }
  return `linear-gradient(${deg}deg, ${getGradientColorStops(colors)})`;
}
function radialGradient() {
  for (var _len2 = arguments.length, colors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    colors[_key2] = arguments[_key2];
  }
  return `radial-gradient(circle, ${getGradientColorStops(colors)})`;
}
function gradient(theme) {
  const getThemeColor = themeColor(theme);
  const getPrimaryShade = primaryShade(theme);
  return payload => {
    const merged = {
      from: (payload == null ? void 0 : payload.from) || theme.defaultGradient.from,
      to: (payload == null ? void 0 : payload.to) || theme.defaultGradient.to,
      deg: (payload == null ? void 0 : payload.deg) || theme.defaultGradient.deg
    };
    return `linear-gradient(${merged.deg}deg, ${getThemeColor(merged.from, getPrimaryShade(), false)} 0%, ${getThemeColor(merged.to, getPrimaryShade(), false)} 100%)`;
  };
}
export { gradient, linearGradient, radialGradient };